import api from './api';

export const emailSettingsService = {
    // Get settings
    getSettings: () => api.get('/emailsettings'),

    // Update settings
    updateSettings: (data) => api.put('/emailsettings', data),

    // Optional: Test connection endpoint (trebuie implementat in backend daca il vrei)
    testConnection: (data) => api.post('/emailsettings/test', data)
};